import defaultWebPaymentSelection from '#themes/default/web/components/paymentSelection/paymentSelection.js';

import cBillingSummary from '#themes/avast/web/components/billingSummary/billingSummary.js';
import cCardInput from '#themes/avast/web/components/cardInput/cardInput.js';
import cContentLayout from '#themes/avast/web/layouts/contentLayout/contentLayout.js';
import cCvcHint from '#themes/avast/web/components/cvcHint/cvcHint.js';
import cDropdown from '#themes/avast/web/components/dropdown/dropdown.js';
import cLegalAgreement from '#themes/avast/web/components/legalAgreement/legalAgreement.js';
import cProvidersElement from '#themes/avast/web/components/providersElement/providersElement.js';
import cSvg from '#themes/avast/web/components/svg/svg.js';
import cTooltip from '#themes/avast/web/components/tooltip/tooltip.js';

export default {
	components: {
		cBillingSummary,
		cCardInput,
		cContentLayout,
		cCvcHint,
		cDropdown,
		cLegalAgreement,
		cProvidersElement,
		cSvg,
		cTooltip
	},
	extends: defaultWebPaymentSelection
};
